import { FlexComponent, ModuleDefinition } from "src/typings/flexFramework/FlexComponent";
import { BlossomComponent } from "components/flexFramework/domain/BlossomComponent";
import { BlossomComponentFromComposition } from "components/flexFramework/domain/BlossomComponentFromComposition";
import { BlossomComponentFromTemplate } from "components/flexFramework/domain/BlossomComponentFromTemplate";

interface BlossomComponentFactoryProps {
  flexComponents?: FlexComponent[];
  moduleDefinitions?: ModuleDefinition[];
}

/**
 * Factory that helps get Blossom Components based on the given props
 */
export class BlossomComponentsFactory {
  public static get = (props: BlossomComponentFactoryProps): BlossomComponent[] => {
    if (!props) {
      return [];
    }

    if (props.moduleDefinitions && props.moduleDefinitions.length > 0) {
      return [
        ...props.moduleDefinitions.map(component => new BlossomComponentFromTemplate(component))
      ];
    }

    if (props.flexComponents && props.flexComponents.length > 0) {
      return [
        ...props.flexComponents.map(component => new BlossomComponentFromComposition(component))
      ];
    }

    return [];
  };
}
